/**
 * en-GB messages added by Phase 2 task S12 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s12EnGB = {
    'notify.skip.sms_off': 'SMS is switched off, so this text was not sent.',
    'notify.skip.bad_number': 'The phone number is not valid, so this text was not sent.',
    'notify.skip.push_off': 'Push notifications are switched off, so this was not sent.',
    'notify.skip.device_not_registered': 'The device no longer accepts notifications, so it has been switched off.',
    'notify.error.sms_provider': 'The text message service did not accept the message. It will be tried again.',
    'notify.error.push_provider': 'The push service could not be reached. It will be tried again.',
    'notify.error.push_rejected': 'The push service rejected this notification.',
};
//# sourceMappingURL=s12.js.map